module.exports = __webpack_public_path__ + "static/amplify-2d9b8cf2affc889876bd6632bb7fbee5.gif";